import React, { useContext, useState } from "react";
// import FriendlyInfo from "../../../../components/FriendlyInfo";
// import useFetch from "../../../../hooks/useFetch";
import { useNavigate } from "react-router";
import * as a from "../../../../constants/api";
// import * as h from "../../../../helpers";
import * as r from "../../../../constants/routes";
import ButtonsArea from "../../../../components/Buttons/ButtonsArea";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import pClasses from "../Users.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import Spinner from "../../../../components/Spinner";
import useFetch from "../../../../hooks/useFetch";
import { useTranslation } from "react-i18next";
import { isSameText, isValidEmail } from "../../../../helpers";
import InputText from "../../../../components/Inputs/InputText";
import {
  EMAIL,
  GA_INFO_NOT_IDENTIFIED,
  GA_USER_TYPE_ADMIN,
  SUBMIT,
} from "../../../../constants/defaults";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { setAnalyticsNumUsersAdded } from "../../../../helpers/analyticsHelpers";
import SessionContext from "../../../../context/sessionContext";

export default function UserAdd() {
  const history = useNavigate();
  const [email, setEmail] = useState("");
  const [lastEmailAdd, setLastEmailAdd] = useState<string | null>(null);
  const { t } = useTranslation();
  const [error, setError] = useState(false)
  const [, isLoading, hasError, fetchNewUser]: any = useFetch({
    // TODO show img error upload
    autoInit: false,
  });

  const { company_uid } = useContext(SessionContext);

  const postListHandler = () => {
    setLastEmailAdd(null);
    fetchNewUser({
      url: a.API_PRO,
      method: "POST",
      data: { email },
      onSuccess: () => {
        setAnalyticsNumUsersAdded({
          number: "1",
          company_uid: company_uid ?? GA_INFO_NOT_IDENTIFIED,
          user_type: GA_USER_TYPE_ADMIN ?? GA_INFO_NOT_IDENTIFIED,
        });
        setLastEmailAdd(email);
        setEmail("");
        setError(false)
      },
      onError: () => {
        setError(true)
      },
    });
  };

  let _confirmTop = (
    <form
      action={"Update"}
      className={pClasses.InnerForm}
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <InputText
        label={t("global.email")}
        fake={isLoading}
        onChange={(newEmail: string) => {
          setEmail(newEmail);
          if (lastEmailAdd !== null) setLastEmailAdd(null);
        }}
        required={true}
        type={EMAIL}
        value={email}
      />

      {lastEmailAdd && (
        <p className={pClasses.InfoText}>
          <strong>{lastEmailAdd}</strong> foi cadastrado com sucesso
          <FontAwesomeIcon icon={faCheck} />
        </p>
      )}
      <ButtonsArea rowReverse>
        <RoundButton
          small
          type={SUBMIT}
          disabled={!isValidEmail(email)}
          title={t("global.confirm_new_admin") + ":" + email}
          text={t("global.confirm")}
          onClick={postListHandler}
        />
        <RoundButton
          borderLess
          small
          title={"Cancelar e voltar a área de upload"}
          text={t("global.back")}
          onClick={() => {
            history("/");
          }}
        />
      </ButtonsArea>
    </form>
  );

  let _contentBottom = null;
  if (hasError && error) {
    let hasErrorMsg = t("infos.something_wrong_try_again");

    const { message, limit } = hasError.data ?? hasError;

    if (message && isSameText(message, a.FILE_MORE_USERS_THAN_LIMIT))
      hasErrorMsg = t("api_errors." + message) + " " + (limit ?? "");
    else hasErrorMsg = t("api_errors." + message);
    _contentBottom = (
      <FriendlyInfo className={pClasses.Mt} isError text={hasErrorMsg} />
    );
  } else if (isLoading) {
    _confirmTop = <Spinner center />;
  }

  if (!error) _contentBottom = null
  
  const userUpdateClasses = pClasses.Users + " " + pClasses.Center;

  return (
    <>
      <PageHeader
        title={"Cadastrar Admin"}
        subtitle={
          "Você poderá mudar as permissões para SuperAdmin no gerenciamento de usuários"
        }
        btnText={t("global.manage_all_admin")}
        btnClick={() => history(r.R_A_PRO_LIST)}
      />
      <PageMain className={userUpdateClasses}>
        {_confirmTop}
        {!isLoading && _contentBottom}
      </PageMain>
    </>
  );
}
